import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Button, message } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import './index.scss';
import LayoutHead from '../components/header';
import ChildHead from '../components/childHead';
import NoData from '@/components/no-data';
import { dispatch, RootState } from '@/redux/store';
import { getAddressList, setEditModalState } from '@/redux/address';
import { useSelector } from 'react-redux';
import { setCartCount } from '@/features/user/userSlice';
import AddressCell, { EmptyAddressCell } from '../address/address-cell';
import OrderCell from '../components/order-cell';
import { getTempDate, getUserBillBaseList, createOrder, orderCountTotal } from '@/api/personal-center';
import { getTotalPrice, OrderProduct,getFinalPrice } from './model';
import InvoiceCell from '../components/invoice-cell';
import { IInvoiceItem } from '../invoice/type';
import InvoiceModal from '../invoice/components/add-modal'
import { deleteCartGoods } from '@/api/shopping';
import Card from './card'
import { useDebounce } from '@/hooks';
import {couponList} from '@/api/coupon'



const ProductOrder: React.FC = () => {
  const navigate = useNavigate();
  const { addressesList } = useSelector((state: RootState) => state.addressReducer);
  const { selectedGoods } = useSelector((state: RootState) => state.orderReducer);
  // 暂时这么处理订单列表
  const [orderList, setOrderList] = useState<OrderProduct[]>([]);
  const [summaryData, setSummaryData] = useState<any>({});
  const [userInvoiceList, setUserInvoiceList] = useState<IInvoiceItem[]>([]);
  const [addressId, setAddressId] = useState<number>();
  const [invoiceId, setInvoiceId] = useState<number>();
  const [showAddModal, setShowAddModal] = useState(false);
  const [cardId, setCardId] = useState<number>();
  const [couponData, setCouponData] = useState<any>([]);
  const [searchParams] = useSearchParams();
  const isDetail = searchParams.get('type');//从详情跳转过来的带了type='detail',从购物车没带参数
  const params = useParams();
  // const couponLists:any = [
  //   {
  //     id: 1,
  //     count:10
      
  //   },
  //   {
  //     id: 2,
  //     count:20
  //   },
  //   {
  //     id: 3,
  //     count:5
  //   },
  //   {
  //     id: 4,
  //     count:30
  //   }
  // ]
  useEffect(() => {
    getTempDate().then((res: any) => {
      if (res.success) {
        if (res.obj) {
          const obj = res.obj;
          // 设置里面的商品
          setOrderList(res.obj);
          // 设置总计信息
          // 获取总计个数
          const totalCount = res.obj?.reduce((p: number, c: OrderProduct) => {
            return p + c.quantity;
          }, 0);
          const totalAmount = getTotalPrice(res.obj);
          // 使用函数式更新来确保使用最新的 summaryData 状态
          setSummaryData((prevSummaryData: any) => ({
            ...prevSummaryData,
            obj,
            totalCount,
            totalAmount
          }));
        } else { 
          setOrderList([]);
        }
      } else {
        message.error(res.message);
      }
    });
    // } else {
    // 设置里面的商品
    // setOrderList(selectedGoods);
    // // 设置总计信息
    // // 获取总计个数
    // const totalCount = selectedGoods.reduce((p: number, c: OrderProduct) => {
    //   return p + c.quantity;
    // }, 0);
    // // 获取总价
    // const totalAmount = getTotalPrice(selectedGoods);
    // const _sumData = {
    //   totalCount,
    //   totalAmount,
    //   discountAmount: 0,
    //   freightAmount: 0,
    //   productList: selectedGoods,
    // };
    // setSummaryData(_sumData);
    // }
  }, []);
  useEffect(() => { 
    if (cardId) {
     const couponAmount = couponData?.find((item:any)=>item.id===cardId)?.amount
      const totalAmount = getFinalPrice(summaryData.totalAmount,couponAmount);
      // const totalAmount = getFinalPrice('200.00','300.00');
      // console.log(totalAmount,Number(totalAmount),Number(totalAmount)<0,'totalAmount')
      // 使用函数式更新来确保使用最新的 summaryData 状态
      setSummaryData((prevSummaryData: any) => ({
        ...prevSummaryData,
        finalAmount:Number(totalAmount)>0?totalAmount:'0.00'
      }));
    } else {//取消勾选，重新设置默认值，不然会保留上一次减去优惠券的金额
      // 使用函数式更新来确保使用最新的 summaryData 状态
      setSummaryData((prevSummaryData: any) => ({
        ...prevSummaryData,
        finalAmount:prevSummaryData.totalAmount
      }));
     }
  },[cardId])
  useEffect(() => {
    refreshInvoiceList();
    // if (userInvoiceList.length > 0) {
    //   setInvoiceId(userInvoiceList[0].id);
    // }
  }, []);

  // toggle 地址列表
  const [isShowAllAddress, setIsShowAllAddress] = useState(false);
  // toggle 发票列表
  const [isShowAllInvoice, setIsShowAllInvoice] = useState(false);
  // toggle 地址列表
  const [isShowAllCoupon, setIsShowAllCoupon] = useState(false);
  // useEffect(() => {
  //   refreshInvoiceList();
  //   // if (userInvoiceList.length > 0) {
  //   //   setInvoiceId(userInvoiceList[0].id);
  //   // }
  // }, []);

  useEffect(() => {
    setAddressId(addressesList.find((item: any) => item.defaultStatus === 1)?.id || 0);
    const address = addressesList.find((item: any) => item.defaultStatus === 1)
    if (address && Object.keys(address).length > 0) {
      // setSummaryData({...summaryData,address})
      setSummaryData((prevSummaryData: any) => ({
        ...prevSummaryData,
        address
      }));
    }

  }, [addressesList])

  useEffect(() => {
    dispatch(getAddressList()); // 第一次进来获取收货地址列表
    if (addressesList.length > 0) {
      setAddressId(addressesList[0].id);
    }
  }, [dispatch]);

  // 获取开票信息列表
  useEffect(() => {
    refreshInvoiceList();
  }, [showAddModal])

  // 获取优惠券列表
useEffect(()=>{
  handleCouponList();
},[])

  /** 获取发票列表 */
  const refreshInvoiceList = () => {
    getUserBillBaseList().then((res: any) => {
      if (res.success) {
        setUserInvoiceList(res.obj);
        setInvoiceId(res.obj.find((item: any) => item.defaultStatus === 1)?.id || 0);

      } else {
        message.error(res.message);
      }
    });
  };

  // 新增
  const addRecord = () => {
    dispatch(setEditModalState({ isAdd: true, open: true, title: '新增收货地址', id: '' }));
  };

  // 生成订单后，删除当前商品信息
  const handleDelete = (cartIds: any) => {
    deleteCartGoods(cartIds).then((res: any) => {
      if (res.success) {
        // message.success('删除成功！');
        // refreshInvoiceList();
        cartCountFunc();
      } else {
        message.error(res.message);
      }
    });
  };
  // 获取购物车数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes: any) => {
      if (oRes.success) {
        dispatch(setCartCount(oRes.obj?.cartNum ?? 0));
      }
    })
  }

  // 创建订单
  const onSubmit = () => {
    if (!addressId) {
      message.warning('请先选择收货地址');
      return false;
    }

    // 包装对象
    const products = summaryData.obj?.map((v: OrderProduct) => {
      return {
        productId: v.productId,
        productSn: v.productSn,
        quantity: v.quantity,
        productName: v.productName,
        prices:orderList[0]?.prices,
        // relates 是所有type不为1的集合
        // relates: v.models.filter((c: { type: number; id: number }) => c.type !== 1).map((c: { type: number; id: number }) => c.id),
        relates: v.models.map((c: { type: number; id: number }) => c.id),
      };
    });
    const arr:any[] = [];
    cardId&&arr?.push(cardId)
    // console.log(cardId&&arr?.push(cardId),'cardId')
    const params = {
      products,
      totalMoney: summaryData?.totalAmount,
      addressId: addressId,
      billBaseId: invoiceId,
      coupons: arr,
     
      // 根据 isDetail 的值决定是否添加 cartIds 属性
      ...(isDetail !== 'detail' && { cartIds: summaryData.obj?.map((v: OrderProduct) => v.id) })
    };
  
    const cartIds = summaryData.obj?.map((v: OrderProduct) => v.productId);
    // handleDelete(cartIds.join(','));
    console.log(summaryData,summaryData.finalAmount,params.totalMoney,params.totalMoney==='0.00','finalAmount')
    createOrder({ ...params }).then((res: any) => {
      if (res.success) {
        handleDelete(cartIds);

      // 如果实付小于等于0(summaryData.finalAmount),直接跳到成功页，否则跳到支付页 totalMoney
        // console.log(summaryData,summaryData.finalAmount,Number(summaryData.finalAmount),'summaryData.finalAmount')
        if (Number(summaryData.finalAmount) < 0 || Number(summaryData.finalAmount) === 0 ||params.totalMoney==='0.00') { 
          navigate(`/user/payment/success?orderId=${res.obj.id}&payWay=/`)
          
        } else {
          navigate(`/user/payment?orderId=${res.obj.id}`);
         }
      } else {
        message.error(res.message);
      }
    })

  };
  const handleSubmit = useDebounce(
    onSubmit
  )
  const handleChangeAddress = (id: number) => {
    setAddressId(id);
    const address = addressesList.find(item => item.id === id);
    setSummaryData({ ...summaryData, address })
  }

  const handleInvoiceId = (id: number) => {
    if (id === invoiceId) {
      setInvoiceId(0);
    } else {
      setInvoiceId(id);
    }

  }
  // 获取优惠券列表
  const handleCouponList = () => { 
    couponList({useStatus:1}).then((res:any) => {
      if (res.success) {
        setCouponData(res?.obj??[]);
      } else { 
        message.error(res.message);
      }
    })
  }
  console.log(couponData,couponData&&couponData?.find((item:any)=>item.id===cardId)?.amount,'cardId')
  return (
    <div className="order-page">
      <LayoutHead title="核对订单" isCheckOrder={true}></LayoutHead>

      {orderList.length>0?<div className="content">
        <div className="child-page-wrap">
          <div className="child-page">
            <div className="address-box">
            {addressesList.length === 0 && <ChildHead title="收货地址" underline={false} callback={addRecord} />}
              {addressesList.length > 0 && <ChildHead title="收货地址" rightText="新增收货地址" underline={false} callback={addRecord} />}
              <div className="address-list">
                {addressesList.length > 0 ? (
                  (isShowAllAddress ? addressesList : addressesList.slice(0, 2)).map((item) => {
                    return <AddressCell
                      addressId={addressId}
                      onClick={() => handleChangeAddress(item.id)}
                      key={item.id}
                      {...item}
                    />;
                  })
                ) : (
                  <EmptyAddressCell />
                )}
              </div>
              {addressesList.length >= 3 && <div
                className="toggle-btn"
                onClick={() => setIsShowAllAddress(!isShowAllAddress)}
              >
                <span className='text'>
                  {isShowAllAddress ? '收起全部地址' : '查看全部地址'}
                </span>
                {isShowAllAddress ? <UpOutlined /> : <DownOutlined />}
              </div>}
            </div>

            <div className="order-box">
              <ChildHead title="商品" />
              <div className="order-list">
                {orderList?.length > 0 ?
                  orderList?.map((item: OrderProduct) => {
                    return (
                      <React.Fragment key={item.id}>
                        <OrderCell key={item.id} {...item} />
                      </React.Fragment>
                    )
                  }) : ''}
              </div>
            </div>

            <div className="invoice-box">
              <div className="child-head">
                <div className="child-title">
                  <span>发票</span>
                </div>
                {userInvoiceList.length >= 2 && <div className="handles">
                  <div className="toggle-btn" onClick={() => setIsShowAllInvoice(!isShowAllInvoice)}>
                    <span className='text'>{isShowAllInvoice ? '收起全部发票抬头' : '查看全部发票抬头'}</span>
                    {isShowAllInvoice ? <UpOutlined /> : <DownOutlined />}
                  </div>
                </div>}
              </div>
              <div className="invoice-list">
                {userInvoiceList.length > 0 ? (
                  (isShowAllInvoice ? userInvoiceList : userInvoiceList.slice(0, 1)).map((item) => {
                    return <InvoiceCell
                      key={item.id}
                      {...item}
                      invoiceId={invoiceId ?? 0}
                      onClick={(id: number) => handleInvoiceId(id)}
                      refreshInvoiceList={() => refreshInvoiceList()}
                    />;
                  })
                ) : (
                  <div style={{ padding: '20px 0 0' }}>
                    <span className="link" onClick={() => setShowAddModal(true)}>
                      去填写
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="delivery-box">
              <ChildHead title="配送" underline={false} />
              <div className="delivery-list">
                <span>
                  商品由 <span>本源量子商城</span> 合作快递配送
                </span>
              </div>
            </div>

            <div className="discount-box">
              <ChildHead title="优惠券" underline={false} />
              {couponData.length > 0 ? (<div className="coupon-list">
               
                {(isShowAllCoupon ? couponData : couponData.slice(0, 3)).map((item: any) => {
                  return <Card
                    // type={item.type}
                    id={item.id}
                    setCardId={setCardId}
                    cardId={cardId}
                    // addressId={addressId}
                    // onClick={()=>handleChangeAddress(item.id)}
                    key={item.id}
                    {...item}
                  />;
                })}
                </div>
                ) : (
                  <div className="discount-list" style={{marginBottom:'-100px'}}>
                  <NoData title="您没有优惠券" ></NoData>
                </div>
                )
                }
              
              {couponData.length >3 && <div className="handles"> <div
                className="toggle-btn"
                onClick={() => setIsShowAllCoupon(!isShowAllCoupon)}
              >
                <span className='text'>
                  {isShowAllCoupon ? '收起全部优惠券' : '查看全部优惠券'}
                </span>
                {isShowAllCoupon ? <UpOutlined /> : <DownOutlined />}
              </div>
              </div>}
                </div>
            <div className="summary-box">
              <div className="price-box">
                <div>
                  <span>商品件数：</span>
                  <span>{summaryData.totalCount}&nbsp;件</span>
                </div>
                <div>
                  <span>商品总价：</span>
                  <span>￥ {summaryData.totalAmount}</span>
                </div>
                <div>
                  <span>优惠券抵扣：</span>
                  {/* <span>-￥ {summaryData.discountAmount}</span> */}
                  <span>-￥ { cardId?couponData?.find((item:any)=>item.id===cardId)?.amount:'0.00'}</span>
                </div>
                <div>
                  <span>运费：</span>
                  {/* <span>-￥ {summaryData.freightAmount}</span> */}
                  <span>￥ 0.00</span>
                </div>
              </div>
              <div className="gray-box">
                <div className="summary-text">
                  <span>应付金额：</span>
                  <span>￥ {summaryData.finalAmount?summaryData.finalAmount:summaryData.totalAmount}</span>
                </div>
                <div className="remind-text">
                  <div className='remind-text-address'>
                    寄送至：&nbsp;{summaryData?.address?.province}&nbsp;
                    {summaryData?.address?.city}&nbsp;
                    {summaryData?.address?.region}&nbsp;
                    {summaryData?.address?.detailAddress}
                  </div>
                  <div>
                    收货人：&nbsp;&nbsp;{summaryData?.address?.name}&nbsp;{summaryData?.address?.tel}
                  </div>
                </div>
              </div>
              <Button type="primary" onClick={handleSubmit}>
                提交订单
              </Button>
            </div>
          </div>
        </div>
      </div> : <NoData title={ `请勾选需要结算的商品<br/><p class='no-data-order'><a href='/home'>去商城首页</a> <a href='/user/cart' class='back-to-cart'>返回购物车</a></p>`} />}
      <InvoiceModal
        showModal={showAddModal}
        setShowAddModal={setShowAddModal}
        invoiceItem={{}}
      />
    </div>
  );
};

export default ProductOrder;
